// extracted by mini-css-extract-plugin
export var active = "_tt-1";
export var circle = "_tt-0";
export var completed = "_tt-2";
export var connector = "_tt-4";
export var connectorCompleted = "_tt-7";
export var connectorSpacer = "_tt-5";
export var iconStrokeOverride = "_tt-8";
export var labelContainer = "_tt-6";
export var pending = "_tt-3";